import React, { useEffect } from 'react';
import { debounce } from 'lodash-es';

export function useWindowSize() {
  const [size, setSize] = React.useState<{ width: number | null; height: number | null }>({
    width: typeof window === 'undefined' ? null : window.innerWidth,
    height: typeof window === 'undefined' ? null : window.innerHeight,
  });

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 250); // Adjust delay as needed

    debouncedHandleResize(); // Initial call

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
      debouncedHandleResize.cancel(); // Cancel any pending debounced calls
    };
  }, []);

  return size;
}
